var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResetLock = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 64,
  fill: "none",
  viewBox: "0 0 58 64",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0F8491",
  fillOpacity: 0.1,
  stroke: "#0F8491",
  strokeWidth: 4,
  d: "M2.334 35.333c0-6.285 0-9.428 1.953-11.38C6.239 22 9.382 22 15.667 22h26.667c6.285 0 9.428 0 11.38 1.953 1.953 1.952 1.953 5.095 1.953 11.38V42c0 9.428 0 14.142-2.929 17.071S45.095 62 35.668 62H22.333c-9.428 0-14.142 0-17.071-2.929S2.334 51.428 2.334 42z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F8491",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M42.334 18.667v-3.334C42.334 7.97 36.364 2 29 2v0c-7.363 0-13.333 5.97-13.333 13.333v3.334"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 29.001,
  cy: 42,
  r: 6.667,
  fill: "#0F8491"
})));
export { SvgResetLock as ReactComponent };
export default __webpack_public_path__ + "assets/images/reset_lock.svg";